module.exports = __webpack_public_path__ + "img/assign_btn.309325a6.svg";